import { component$ } from "@builder.io/qwik";
import { CTASection } from "./ui/cta-section";
import { Button } from "./ui/button";
import { useForm, valiForm$ } from "@modular-forms/qwik";
import { Input } from "./ui/input";
import { ErrorMessage, FormField } from "./ui/form-field";
import type { LeadMagnetForm } from "~/routes/[username]/(profile)/layout";
import {
  LeadMagnetFormSchema,
  useSubmitLeadAction,
} from "~/routes/[username]/(profile)/layout";

export interface LeadMagnetInfo {
  leadMagnetTitle: string;
  leadMagnetDescription?: string | null;
  leadMagnetCtaText?: string | null;
}

export const CoachLeadMagnet = component$<LeadMagnetInfo>(
  ({ leadMagnetTitle, leadMagnetDescription, leadMagnetCtaText }) => {
    const action = useSubmitLeadAction();
    const [form, { Form, Field }] = useForm<LeadMagnetForm, { url: string }>({
      loader: {
        value: {
          firstName: "",
          email: "",
        },
      },
      action,
      validate: valiForm$(LeadMagnetFormSchema),
    });

    return (
      <CTASection
        title={leadMagnetTitle}
        description={leadMagnetDescription ?? undefined}
      >
        {form.response?.status === "success" ? (
          <div class="mt-4 flex flex-col items-center gap-4">
            <p>Thank you!</p>
            <a
              href={form.response.data!.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button variant="fancy" size="lg">
                {leadMagnetCtaText ?? "Get Instant Access"}
              </Button>
            </a>
          </div>
        ) : (
          <Form class="mt-4">
            <Field name="firstName">
              {(field, props) => (
                <FormField label="First Name" error={field.error}>
                  <Input {...props} placeholder="First Name..." />
                </FormField>
              )}
            </Field>
            <Field name="email">
              {(field, props) => (
                <FormField label="Email" error={field.error}>
                  <Input {...props} placeholder="Email..." />
                </FormField>
              )}
            </Field>
            <Button
              variant="fancy"
              size="lg"
              type="submit"
              disabled={form.submitting}
              class="mt-2"
            >
              {leadMagnetCtaText ?? "Get Instant Access"}
            </Button>
            {form.response?.status === "error" && (
              <div class="mt-2">
                <ErrorMessage error={form.response.message} />
              </div>
            )}
          </Form>
        )}
      </CTASection>
    );
  },
);
